import React from 'react';
import IframePage from './IframePage';

export default function EcosystemePortailsPage() {
  return (
    <IframePage
      title="Écosystème des portails"
      url="https://sys.ecotechsystem.ca"
    />
  );
}
